<template>
    <div class="con">
        <div class="map-service">
            <div class="map-service-right">
                <div class="china-map">
<!--                    <div class="region-list postition-1">-->
<!--                        <div class="area-box">-->
<!--                            <span class="dot"></span>-->
<!--                            <span class="pulse delay-01"></span>-->
<!--                            <span class="pulse delay-02"></span>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="region-list active postition-2 online-node">
                        <div class="area-box"><span class="dot"></span><span class="pulse delay-06"></span>
                            <span class="pulse delay-05"></span>
                            <span class="pulse delay-04"></span></div>
                        <div class="show-regin"><span>{{$t('city')[0]}}</span></div>
                    </div>

                    <div class="region-list active postition-27 online-node">
                        <div class="area-box"><span class="dot"></span><span class="pulse delay-06"></span>
                            <span class="pulse delay-05"></span>
                            <span class="pulse delay-04"></span></div>
                        <div class="show-regin"><span>{{$t('city')[1]}}</span></div>
                    </div>

                    <div class="region-list active postition-28 online-node">
                        <div class="area-box"><span class="dot"></span><span class="pulse delay-06"></span>
                            <span class="pulse delay-05"></span>
                            <span class="pulse delay-04"></span></div>
                        <div class="show-regin"><span>{{$t('city')[2]}}</span></div>
                    </div>



                    <div class="region-list active postition-29 online-node">
                        <div class="area-box"><span class="dot"></span><span class="pulse delay-06"></span>
                            <span class="pulse delay-05"></span>
                            <span class="pulse delay-04"></span></div>
                        <div class="show-regin"><span>{{$t('city')[3]}}</span></div>
                    </div>


                    <div class="region-list active postition-30 online-node">
                        <div class="area-box"><span class="dot"></span><span class="pulse delay-06"></span>
                            <span class="pulse delay-05"></span>
                            <span class="pulse delay-04"></span></div>
                        <div class="show-regin"><span>{{$t('city')[4]}}</span></div>
                    </div>

                    <div class="region-list active postition-31 online-node">
                        <div class="area-box"><span class="dot"></span><span class="pulse delay-06"></span>
                            <span class="pulse delay-05"></span>
                            <span class="pulse delay-04"></span></div>
                        <div class="show-regin"><span>{{$t('city')[5]}}</span></div>
                    </div>

                    <div class="region-list active postition-18 online-node">
                        <div class="area-box"><span class="dot"></span><span class="pulse delay-06"></span>
                            <span class="pulse delay-05"></span>
                            <span class="pulse delay-04"></span></div>
                        <div class="show-regin"><span>{{$t('city')[6]}}</span></div>
                    </div>

                    <div class="region-list waite postition-4 waite-node">
                        <div class="area-box"><span class="dot"></span><span class="pulse delay-01"></span>
                            <span class="pulse delay-02"></span>
                        </div>
                        <div class="show-regin"><span>{{$t('city')[7]}}</span></div>
                    </div>

                    <div class="region-list waite postition-15 waite-node">
                        <div class="area-box"><span class="dot"></span><span class="pulse delay-01"></span>
                            <span class="pulse delay-02"></span>
                        </div>
                        <div class="show-regin"><span>{{$t('city')[8]}}</span></div>
                    </div>

                    <div class="region-list waite postition-5 waite-node">
                        <div class="area-box"><span class="dot"></span><span class="pulse delay-01"></span>
                            <span class="pulse delay-02"></span>
                        </div>
                        <div class="show-regin"><span>{{$t('city')[9]}}</span></div>
                    </div>

                    <div class="region-list waite postition-16 waite-node">
                        <div class="area-box"><span class="dot"></span><span class="pulse delay-01"></span>
                            <span class="pulse delay-02"></span>
                        </div>
                        <div class="show-regin"><span>{{$t('city')[10]}}</span></div>
                    </div>

                    <div class="region-list waite postition-32 waite-node">
                        <div class="area-box"><span class="dot"></span><span class="pulse delay-01"></span>
                            <span class="pulse delay-02"></span>
                        </div>
                        <div class="show-regin"><span>{{$t('city')[11]}}</span></div>
                    </div>

                    <div class="region-list active postition-6 online-node">
                        <div class="area-box"><span class="dot"></span><span class="pulse delay-06"></span>
                            <span class="pulse delay-05"></span>
                            <span class="pulse delay-04"></span></div>
                        <div class="show-regin"><span>{{$t('city')[12]}}</span></div>
                    </div>
<!--                    <div class="region-list active postition-13 online-node">-->
<!--                        <div class="area-box"><span class="dot"></span><span class="pulse delay-04"></span>-->
<!--                            <span class="pulse delay-05"></span>-->
<!--                            <span class="pulse delay-03"></span></div>-->
<!--                        <div class="show-regin"><span>内蒙古</span></div>-->
<!--                    </div>-->
                    <div class="region-list  active  postition-11 online-node">
                        <div class="area-box"><span class="dot"></span><span class="pulse delay-06"></span>
                            <span class="pulse delay-05"></span>
                            <span class="pulse delay-04"></span></div>
                        <div class="show-regin"><span>{{$t('city')[13]}}</span></div>
                    </div>
                    <div class="region-list active postition-7 online-node">
                        <div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
                            <span class="pulse delay-09"></span>
                            <span class="pulse delay-08"></span></div>
                        <div class="show-regin"><span>{{$t('city')[14]}}</span></div>
                    </div>

                    <div class="region-list active postition-23 online-node">
                        <div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
                            <span class="pulse delay-09"></span>
                            <span class="pulse delay-08"></span></div>
                        <div class="show-regin"><span>{{$t('city')[15]}}</span></div>
                    </div>

                    <div class="region-list active postition-24 online-node">
                        <div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
                            <span class="pulse delay-09"></span>
                            <span class="pulse delay-08"></span></div>
                        <div class="show-regin"><span>{{$t('city')[16]}}</span></div>
                    </div>

<!--                    <div class="region-list active postition-25 online-node">-->
<!--                        <div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>-->
<!--                            <span class="pulse delay-09"></span>-->
<!--                            <span class="pulse delay-08"></span></div>-->
<!--                        <div class="show-regin"><span>{{$t('city')[17]}}</span></div>-->
<!--                    </div>-->

<!--                    <div class="region-list active postition-26 online-node">-->
<!--                        <div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>-->
<!--                            <span class="pulse delay-09"></span>-->
<!--                            <span class="pulse delay-08"></span></div>-->
<!--                        <div class="show-regin"><span>{{$t('city')[18]}}</span></div>-->
<!--                    </div>-->

                    <div class="region-list active postition-8 online-node">
                        <div class="area-box"><span class="dot"></span><span class="pulse delay-06"></span>
                            <span class="pulse delay-05"></span>
                            <span class="pulse delay-04"></span></div>
                        <div class="show-regin"><span>{{$t('city')[19]}}</span></div>
                    </div>
                    <div class="region-list active postition-19 online-node">
                    <div class="area-box"><span class="dot"></span><span class="pulse delay-06"></span>
                        <span class="pulse delay-05"></span>
                        <span class="pulse delay-04"></span></div>
                    <div class="show-regin"><span>{{$t('city')[20]}}</span></div>
                </div>

                    <div class="region-list active postition-20 online-node">
                        <div class="area-box"><span class="dot"></span><span class="pulse delay-06"></span>
                            <span class="pulse delay-05"></span>
                            <span class="pulse delay-04"></span></div>
                        <div class="show-regin"><span>{{$t('city')[21]}}</span></div>
                    </div>

                    <div class="region-list active postition-21 online-node">
                        <div class="area-box"><span class="dot"></span><span class="pulse delay-06"></span>
                            <span class="pulse delay-05"></span>
                            <span class="pulse delay-04"></span></div>
                        <div class="show-regin"><span>{{$t('city')[22]}}</span></div>
                    </div>

                    <div class="region-list active postition-22 online-node">
                        <div class="area-box"><span class="dot"></span><span class="pulse delay-06"></span>
                            <span class="pulse delay-05"></span>
                            <span class="pulse delay-04"></span></div>
                        <div class="show-regin"><span>{{$t('city')[23]}}</span></div>
                    </div>

                    <div class="region-list active postition-9 online-node">
                        <div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
                            <span class="pulse delay-09"></span>
                            <span class="pulse delay-08"></span></div>
                        <div class="show-regin"><span>{{$t('city')[24]}}</span></div>
                    </div>
                    <div class="region-list active postition-10 online-node">
                        <div class="area-box"><span class="dot"></span><span class="pulse delay-06"></span>
                            <span class="pulse delay-05"></span>
                            <span class="pulse delay-04"></span></div>
                        <div class="show-regin"><span>{{$t('city')[25]}}</span></div>
                    </div>

                    <div class="region-list active postition-33 online-node">
                        <div class="area-box"><span class="dot"></span><span class="pulse delay-06"></span>
                            <span class="pulse delay-05"></span>
                            <span class="pulse delay-04"></span></div>
                        <div class="show-regin"><span>{{$t('city')[26]}}</span></div>
                    </div>

                    <div class="region-list active postition-17 online-node">
                        <div class="area-box"><span class="dot"></span><span class="pulse delay-06"></span>
                            <span class="pulse delay-05"></span>
                            <span class="pulse delay-04"></span></div>
                        <div class="show-regin"><span>{{$t('city')[27]}}</span></div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "map"
    }
</script>
<style >
    *{margin:0;padding:0;list-style-type:none;}
    a,img{border:0;text-decoration:none;}

    .clearfix:after{visibility:hidden;display:block;font-size:0;content:" ";clear:both;height:0}
    *html .clearfix{height:1%}


    .map-service{position:relative;height:760px;}
    .map-service-right{padding-top:60px}
    .china-map{width:100%;height:600px;background:url(../assets/home/map.png) center no-repeat;position:relative;background-size: 100% 100%;}
    .region-list{position:absolute;left:0;top:0}

    @-webkit-keyframes warn{
        0%{-webkit-transform:scale(0);transform:scale(0);opacity:1}
        100%{-webkit-transform:scale(1);transform:scale(1);opacity:0}
    }
    @-moz-keyframes warn{
        0%{-moz-transform:scale(0);transform:scale(0);opacity:1}
        100%{-moz-transform:scale(1);transform:scale(1);opacity:0}
    }
    @-o-keyframes warn{
        0%{-o-transform:scale(0);transform:scale(0);opacity:1}
        100%{-o-transform:scale(1);transform:scale(1);opacity:0}
    }
    @keyframes warn{
        0%{-webkit-transform:scale(0);-moz-transform:scale(0);-o-transform:scale(0);transform:scale(0);opacity:1}
        100%{-webkit-transform:scale(1);-moz-transform:scale(1);-o-transform:scale(1);transform:scale(1);opacity:0}
    }
    .area-box .dot{position:absolute;left:0;width:10px;height:10px;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;background:#a2a9b4;opacity:1;filter:alpha(opacity=100)}
    .area-box .pulse{position:absolute;top:-28px;left:-28px;height:66px;width:66px;border:2px solid #b7b7b7;-webkit-border-radius:48px;-moz-border-radius:48px;border-radius:48px;-webkit-box-shadow:0 0 4px #82878f,0 0 10px #82878f inset;-moz-box-shadow:0 0 4px #82878f,0 0 10px #82878f inset;box-shadow:0 0 4px #82878f,0 0 10px #82878f inset;opacity:.12;filter:alpha(opacity=0);-webkit-animation:warn 2s ease-out both;-moz-animation:warn 2s ease-out both;-o-animation:warn 2s ease-out both;animation:warn 2s ease-out both;-webkit-animation-iteration-count:infinite;-moz-animation-iteration-count:infinite;-o-animation-iteration-count:infinite;animation-iteration-count:infinite;background:0 0}
    .area-box .delay-01{-webkit-animation-delay:0;-moz-animation-delay:0;-o-animation-delay:0;animation-delay:0}
    .area-box .delay-02{-webkit-animation-delay:.4s;-moz-animation-delay:.4s;-o-animation-delay:.4s;animation-delay:.4s}
    .area-box .delay-03{-webkit-animation-delay:.8s;-moz-animation-delay:.8s;-o-animation-delay:.8s;animation-delay:.8s}
    .area-box .delay-04{-webkit-animation-delay:1.2s;-moz-animation-delay:1.2s;-o-animation-delay:1.2s;animation-delay:1.2s}
    .area-box .delay-05{-webkit-animation-delay:1.6s;-moz-animation-delay:1.6s;-o-animation-delay:1.6s;animation-delay:1.6s}
    .area-box .delay-06{-webkit-animation-delay:2s;-moz-animation-delay:2s;-o-animation-delay:2s;animation-delay:2s}
    .area-box .delay-07{-webkit-animation-delay:2.4s;-moz-animation-delay:2.4s;-o-animation-delay:2.4s;animation-delay:2.4s}
    .area-box .delay-08{-webkit-animation-delay:-.4s;-moz-animation-delay:-.4s;-o-animation-delay:-.4s;animation-delay:-.4s}
    .area-box .delay-09{-webkit-animation-delay:-.8s;-moz-animation-delay:-.8s;-o-animation-delay:-.8s;animation-delay:-.8s}
    .area-box .delay-10{-webkit-animation-delay:-1.2s;-moz-animation-delay:-1.2s;-o-animation-delay:-1.2s;animation-delay:-1.2s}
    .area-box .delay-11{-webkit-animation-delay:4s;-moz-animation-delay:4s;-o-animation-delay:4s;animation-delay:4s}
    .region-list.active .area-box .dot{background:#009fd9}
    .region-list.active .area-box .pulse{border-color:#009fd9;top:-39px;left:-39px;height:88px;width:88px;-webkit-box-shadow:0 0 12px #0080d9,0 0 20px #0080d9 inset;-moz-box-shadow:0 0 12px #0080d9,0 0 20px #0080d9 inset;box-shadow:0 0 12px #0080d9,0 0 20px #0080d9 inset}
    .region-list.waite .area-box .dot{background:#f90}
    .region-list.waite .area-box .pulse{border-color:#f90}
    .show-regin{position:absolute;left:2px;height:0;top:0;width:11px;opacity:0;-o-transition:all .5s ease-in-out;-webkit-transition:all .5s ease-in-out;-moz-transition:all .5s ease-in-out;transition:all .5s ease-in-out}
    .online-node .show-regin,.region-list:hover .show-regin,.underline-node .show-regin,.waite-node .show-regin{height:127px;opacity:1}
    .show-regin span{width:80px;position:absolute;left:8px;top:-11px;padding:6px 10px;font-size:14px;color:#ccc;-moz-border-radius:2px;-webkit-border-radius:2px;border-radius:2px;white-space:nowrap;}
    .postition-10 .show-regin span{left:0}
    .postition-6 .show-regin span{left:0}
    .area-box{z-index:77}
    .show-regin{z-index:66}
    .region-list.active .show-regin span{position:relative;color:#0C3665}
    .region-list.waite .show-regin span{color:#0C3665}
    .postition-1{left:280px;top:300px}
    .postition-2{left:350px;top:380px}
    .postition-27{left:330px;top:500px}
    .postition-28{left:400px;top:450px}
    .postition-29{left:450px;top:500px}
    .postition-30{left:480px;top:450px}
    .postition-31{left:530px;top:430px}
    .postition-3{left:338px;top:500px}
    .postition-4{left:430px;top:335px}
    .postition-5{left:490px;top:380px}
    .postition-6{left:510px;top:510px}
    .postition-7{left:515px;top:260px}
    .postition-23{left:480px;top:260px}
    .postition-23 .show-regin span{
        left:-40px;
    }
    .postition-24{left:400px;top:280px}
    .postition-25{left:270px;top:220px}
    .postition-26{left:270px;top:280px}
    .postition-7.region-list.active .area-box .pulse{top:-50px;left:-50px;width:110px;height:110px;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%}
    .postition-8{left:530px;top:219px}
    .postition-19{left:553px;top:225px}
    .postition-20{left:600px;top:190px}
    .postition-21{left:630px;top:150px}
    .postition-22{left:650px;top:90px}
    .postition-9{left:585px;top:340px}
    .postition-9.region-list.active .area-box .pulse{top:-50px;left:-50px;width:110px;height:110px;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%}
    .postition-10{left:570px;top:460px}
    .postition-33{left:620px;top:490px}
    .postition-11{left:545px;top:285px}
    .postition-13{left:460px;top:250px}
    .postition-15{left:500px;top:335px}
    .postition-16{left:550px;top:360px}
    .postition-32{left:610px;top:360px}
    .postition-17{left:595px;top:410px}
    .postition-18{left:420px;top:400px}
    .douhao{width:0}
</style>